module.exports = __webpack_public_path__ + "img/card-orange.b400ee6a.svg";